<template>
  <div style="display: none" v-if="ready">
    <iframe ref="ssoIframe" :src="sso"></iframe>
  </div>
</template>
<script>
// import {login} from '@/module/service/oAuth'
import cookie from '@/module/utils/cookie'
import { domain, chat_link } from '@/module/constant'
import { mapMutations } from 'vuex'

export default {
  name: 'Token',
  data() {
    return {
      sso: domain.SSO,
      ready: false
    }
  },
  methods: {
    getMessage(event) {
      // 一次性握手成功后，忽略后续任何消息，避免被翻译插件等扩展注入的污染消息再次触发登录态切换
      if (this.handshaked) return

      var origin = event.origin
      var source = event.source
      var data = event.data

      // 1. origin 必须严格等于 SSO 域，过滤来自当前域 / 扩展协议（chrome-extension://）的消息
      if (origin !== this.sso) return

      // 2. source 必须是本组件挂载的 SSO iframe，防止 SSO 同源下其他脚本（含扩展内容脚本）伪造消息
      var iframe = this.$refs.ssoIframe
      if (!iframe || source !== iframe.contentWindow) return

      // 3. 严格校验数据结构，过滤插件常见的字符串 / null / 异形对象消息
      if (!data || typeof data !== 'object') return

      // 4. 已登录态：res === true 且 token 是非空字符串
      if (data.res === true && typeof data.token === 'string' && data.token.length > 0) {
        this.handshaked = true
        this._saveToken({ clientId: data.id, token: data.token }, () => {
          this.$emit('login', true)
        })
        this.initChat(data.token)
        return
      }

      // 5. 游客态：仅当 SSO 明确返回 res === false 时才视为未登录；其他形态消息一律忽略，避免被污染消息把已登录用户错切回游客
      if (data.res === false) {
        this.handshaked = true
        this._saveToken({ clientId: -1, token: '' }, () => {
          this.$emit('login', false)
        })
        this.initChat('')
      }
    },
    _saveToken(obj, cb) {
      cookie.remove('token')
      cookie.set('token', obj.token) //, domain: window.location.origin
      this.setOAuth({ clientId: obj.clientId })
      cb()
    },
    initChat(t) {
      if (chat_link) {
        let d = window.CHAT_DATA || {}
        d.outer_token = t
        d.chatLink = chat_link
        window.CHAT_DATA = d
        d.bootstrap && d.bootstrap()
      }
    },
    ...mapMutations('oAuth', ['setOAuth'])
  },
  mounted() {
    this.ready = true
  },
  created() {
    // 握手状态标记，挂在实例上避免被 Vue 响应式代理
    this.handshaked = false
    // 用 addEventListener 替代 window.onmessage = ...
    // 直接赋值的写法会被任何后注册的脚本（包括翻译扩展注入的内容脚本）整体覆盖，导致 SSO 的消息根本到不了这里
    this.boundGetMessage = this.getMessage.bind(this)
    window.addEventListener('message', this.boundGetMessage, false)
  },
  beforeDestroy() {
    if (this.boundGetMessage) {
      window.removeEventListener('message', this.boundGetMessage)
      this.boundGetMessage = null
    }
  }
}
</script>
